import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const surveys = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    saloons: [],
    SurveyID: null,
    gallery: [],
  }),
  mutations: {
    setSurveys(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedSurveys(state, payload) {
      state.selectedItems = payload;
    },
    setSurveyPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getSurveys");
    },
    setSurveyTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getSurveys");
    },
  },
  actions: {
    async getSurveys(store) {
      store.state.loading = true;
      await axios
        .post("Survey/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setSurveys", res.data.data);
        });
    },
    async getSurveySaloons(store) {
      await axios.post("Surveysaloon/load").then((res) => {
        store.state.saloons = res.data.data.items;
      });
    },
    async getSurveyGallery(store) {
      await axios
        .post("Surveygallery/load", {
          SurveyID: store.state.SurveyID,
          skip: 0,
          take: 200,
        })
        .then((res) => {
          store.state.gallery = res.data.data.items;
        });
    },
    async toggleSurvey(store, payload) {
      var res = await axios.post("Survey/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteSurvey(store, payload) {
      await axios
        .post("Survey/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setSurveyPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
    async deleteSurveySaloon(store, payload) {
      await axios
        .post("Surveysaloon/delete", {
          id: store.state.saloons[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.saloons.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
          }
        });
    },
    async deleteSurveyGallery(store, payload) {
      await axios
        .post("Surveygallery/delete", {
          id: store.state.gallery[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.gallery.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
          }
        });
    },
  },
  getters: {},
};
export default surveys;



// WEBPACK FOOTER //
// ./src/store/surveys.js